/* global XMLHttpRequest */
'use strict';

var utils = require('../lib/utils');

module.exports = {
  initialise: function initialise(config) {
    this.env = config && config.env;
    this.service = config && config.service;
    var cookie = document.cookie;
    var owts = /owts=([^;]+)/.exec(cookie);
    this.owts = owts && owts[1];
    var sid = /owts-tmp-v2=([^;]+)/.exec(cookie);
    this.sid = sid && sid[1];
  },


  // only track errors to sumo right now
  error: function error(payload) {
    if (!payload) return;

    var endpoint = 'https://endpoint1.collection.eu.sumologic.com/receiver/v1/http/ZaVnC4dhaV3nhn5nRLuyOTKy-c_wfGDCDi-LaECeZ05IhVDhxSV5kJkskWnqKUOsZcBiU8irlEKxDcQ4ZT-T6WmG03Ja8bIoG2o7h3bKMZAchiOhjhtJSg==';
    if (process.env.NODE_ENV !== 'production') {
      endpoint = 'https://endpoint1.collection.eu.sumologic.com/receiver/v1/http/ZaVnC4dhaV311ZLJq8YWw_abJ0dezfxDKJX40d2sV_c9_nYOVnRtOSDsTE2UeSvWmp9-HXxlE70BKT1QAFrDjr3LjXvl9N4HL-7s9PLnTEJYTcqfzco8Yw==';
    }

    try {
      var transformed = {
        url: encodeURI(window.location),
        env: this.env, // pass in env because tripapp does not set NODE_ENV on staging
        owts: this.owts,
        service: this.service,
        sid: this.sid,
        agent: navigator.userAgent,
        timestamp: new Date().toISOString()
      };
      for (var key in payload) {
        transformed[key] = payload[key];
      }
      var xmlHttp = new XMLHttpRequest(); // anything to be saved by reusing this?
      if (process.env.NODE_ENV !== 'production') {
        utils._on(xmlHttp, 'error', console.warn);
      }
      xmlHttp.open('POST', endpoint, true);
      xmlHttp.setRequestHeader('Content-Type', 'application/json');
      xmlHttp.send(utils._stringify(transformed));
    } catch (err) {
      if (process.env.NODE_ENV !== 'production') {
        console.warn(err, payload);
      }
    }
  }
};